import {ConfEnv} from "../../../config/config";
import publicRequest from "../../../Infra/http/private.request";
import {getProviderBaseSlug} from "../../../util/providerNames";
import {formatQueryParams} from "../../../util/queryParams";

export const getTopGamesService = async params => {
  // Normalize "<provider>__<aggregator>" → "<provider>" so the backend resolver
  // can pick whichever aggregator is currently active.
  const normalized = params?.provider ? {...params, provider: getProviderBaseSlug(params.provider)} : params;
  const queryString = formatQueryParams(normalized ? [normalized] : []);
  return publicRequest.get(`${ConfEnv.API_GAMES.TOP_GAMES}${queryString}`);
};
